<!-- Slider main container -->
<button mat-icon-button id="date-button-prev" (click)="onPrev()" [disabled] = "!(isSlotLoading$ | async)">
  <mat-icon>keyboard_arrow_left</mat-icon>
</button>
<div class="dates-wrapper" [ngClass]="{'day-view': viewMode === 'Day', 'week-view': viewMode === 'Week'}">
  <div class="dates" #carousel>
    <div class="date" #dateDiv *ngFor="let date of dateArray; let i = index" (click)="selectDate(i)"
      (keypress)="selectDate(i)"
      [ngClass]="{'selected': currentSelection === i }">
      <div class="date-box" [ngClass]="{'selected': currentSelection === i, 'day-view': viewMode === 'Day' }">
        <div class="date-header">
        <div class='day' [ngClass]="{'selected-day': currentSelection === i }">{{ getTranslation(getDay(date.date)) | uppercase}} </div>
        <span *ngIf='date.bookingPercentage !== null && date.bookingPercentage !== -1'
          [ngStyle]="{'background-image' : getStatusImage(date) }"
          class="statusSpan"></span>
        </div>
      <div class="date-text" [ngClass]="{'selected-date': currentSelection === i }"> {{ getTransformed(date.date) }}</div>
      <div class='slot-text' *ngIf='!(isSlotLoading$ | async)'
        [ngStyle]="{'background-color': '#0E131933' }">
        {{ 'serviceSchedule.loading' | translate}}
      </div>
      <div class='slot-text' *ngIf='(isSlotLoading$ | async)'
        [ngStyle]="{'background-color': getBackgroundColor(date.bookingPercentage, 'slots')}">
        {{(checkDateWithinCacheLimit(date)) ? ('serviceSchedule.notApplicable' | translate) :
          ((date.bookingPercentage !== null && date.bookingPercentage !== -1) ? date.noOfSlotsLeft + ('serviceSchedule.slotsLeft' | translate) : date.bookingPercentage === -1 ? 
        ('serviceSchedule.noSlots' | translate) : ('serviceSchedule.closed' | translate) )}}
      </div>
      <div class='slot-text' *ngIf='(isSlotLoading$ | async) && department === "SERVICE" && !(checkDateWithinCacheLimit(date))'
        [ngStyle]="{'background-color': getBackgroundColor(date.bookingPercentageHrs, 'Hrs')}">
         {{(date.bookingPercentageHrs !== null && date.bookingPercentageHrs !== -1) ? date.noOfHrsLeft + ('serviceSchedule.hoursLeft' | translate) : date.bookingPercentageHrs === -1 ?
          '0'+ ('serviceSchedule.hoursLeft' | translate) : ''}}
      </div>
    </div>
      <div *ngIf="viewMode === 'Week' && (isApptLoading$ | async)">
        <div *ngFor="let team of teamList" style="margin: 5px;"
          [ngStyle]="{'background': getAdvisorSummary(date, team).length === 0 ? '#D1D2D333 0% 0% no-repeat padding-box' : 'white 0% 0% no-repeat padding-box' }">
          <div class="team-name" style="background-color: white;"
            [ngStyle]="{'display' : isApptAvailable(team) ? 'block' : 'none', 'height': i === teamSlide ? '' : '42px' }">
            {{ i === teamSlide ? team.name : ''}} {{ i === teamSlide ? getMaxCount(team)?.total : ''}}
          </div>
          <div class="team-container" [ngStyle]="{height: ((getMaxCount(team)?.max) *7)+ 'rem'}" *ngIf='isApptAvailable(team)'
            >
            <div *ngFor="let advisorSummary of getAdvisorSummary(date, team)" class="appointment-container">
              <app-day-schedule-card [department]='department' [advisorSummary]="advisorSummary"></app-day-schedule-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="no-appointments" *ngIf='(appointmentSummaryForWeekList?.length === 0 && viewMode === "Week" && (isApptLoading$ | async))'>
    <mat-icon class="mat-icon">info_outline</mat-icon>
    <span class="label">{{ 'serviceSchedule.thereAreNoAppointmentsScheduledForTheWeek' | translate }}</span>
  </div>
  <div id="schedule-rotation-loader" style="height: 10rem;" *ngIf="!(isApptLoading$ | async) && viewMode === 'Week'">
    <app-loading loadingSymbol="dots" text="{{'serviceSchedule.loadingAppointmentsForTheWeek' | translate}}" color="var(--primary-sec-color)"></app-loading>
  </div>
</div>
<button mat-icon-button id="date-button-next" (click)="onNext()" [disabled] = "!(isSlotLoading$ | async)">
  <mat-icon>keyboard_arrow_right</mat-icon>
</button>
<ng-template #loader>
  <div id="schedule-rotation-loader">
    <app-loading loadingSymbol="dots" text="{{ 'serviceSchedule.loadingAppointmentsForTheDay' | translate }}"
    color="var(--primary-sec-color)"></app-loading>
  </div>
</ng-template>